/*jshint esversion: 6*/
import classes from 'dom-classes';
import VerticalScroll from './scrolling/vertical-scroll';
const $ = require('jquery');

export default class VerticalScrollFactory {
    constructor(el) {
        this.virtualScrollEl = el;

        this.createExtraBound();
        this.hadleResize();

        $(window).resize(this.hadleResize);
        this.handleDetailPageScroll();
        classes.add(this.virtualScrollEl[0], 'initialized');
    }

    createExtraBound() {
        ['handleDetailPageScroll', 'hadleResize']
            .forEach((fn) => this[fn] = this[fn].bind(this));
    }

    hadleResize() {
        this.window = {
            width: window.innerWidth,
            height: window.innerHeight
        };

        if(classes.has(this.virtualScrollEl[0], 'project-detail-scroll')) {
            const $pagebanner = this.virtualScrollEl.find('.page-banner'),
                $pagebackground = $pagebanner.find('.page-background'),
                $pageTitle = $pagebanner.find('.page-title');

            //$pagebanner.height( this.window.height + (this.window.height * 6 / 100) );
            $pagebanner.height( this.window.height);
           // $pagebackground.height( this.window.height + (this.window.height * 30 / 100) );
            $pagebackground.height( this.window.height );
            $pageTitle.height( this.window.height );
        }
    }    

    handleDetailPageScroll() {
        new VerticalScroll({
            extends: true,
            preload: true,
            noscrollbar: !CCM_EDIT_MODE,
            native: CCM_EDIT_MODE,
            direction: 'vertical',
            ease: 0.06,
            section: this.virtualScrollEl[0],
            divs: this.virtualScrollEl.find('.page-background') || []
        }).init();
    
        // VS.scrollTo(4000);
    }


}


// WEBPACK FOOTER //
// ./app/components/verticalScrollFactory.js